import { LocationQuery } from 'vue-router';
import { http } from '../../../helpers/http.helper';
import { ApiResource } from '../../../models/api-resource.interface';
import { SettingsGroup } from './settings-group.interface';

export class SettingsGroupService {
   async getSettingsGroups(query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<SettingsGroup>>>(`/settings_groups`, { params: { ...query } });
      return response.data;
   }

   async getSettingsGroup(id: number, query?: LocationQuery) {
      const response = await http.get<SettingsGroup>(`/settings_groups/${id}`, { params: { ...query } });
      return response.data;
   }
}
